/*
 * @Author: Teemo Ding
 * @Date: 2022-02-09 15:14:47
 * @LastEditTime: 2022-06-08 11:34:44
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/GiftCardAndStoreCredit/Detail/GiftCardInfo/index.tsx
 */
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { useI18n } from '@/src/hooks/useRouterChange';
import { fixAmountColumns } from '@/src/pages/Settings/Logistics/WarehouseLocations/DeliveryMethod/config';
import { i18nGet } from '@/src/tools/tools';
import React from 'react';
import { Block } from 'src/components/BlocksInRowDisplay';
import { formatMoney } from 'src/tools/helper';
import { EGiftCardType } from 'src/types/common/order';
import Status from './StatusTag';
import css from './css.module.less';

const GiftCardInfo = (props) => {
  const { data, onChangeStatus } = props;

  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  //

  const { status, type, currency, balance, total, createdDate, expireAt } =
    data || {};

  const issuedDate = createdDate || '-';
  const expireDate = expireAt || '-';
  const b = `${currency || ''} ${formatMoney(balance) || '-'}`;
  const t = `${currency || ''} ${formatMoney(total) || '-'}`;
  const _data = [
    {
      title: getI18n('giftCard.giftCardDetail.giftcardinfo_data_currtitle'),
      amount: b,
    },
    {
      title: getI18n('giftCard.giftCardDetail.giftcardinfo_data_denotitle'),
      amount: t,
    },
    {
      title: getI18n('giftCard.giftCardDetail.giftcardinfo_data_issuetitle'),
      amount: issuedDate,
    },
    {
      title: getI18n('giftCard.giftCardDetail.giftcardinfo_data_expiretitle'),
      amount: expireDate,
    },
  ];
  const len = (data || []).length;
  const fixedWidth = len < 4;

  const title = {
    [EGiftCardType.GiftCard]: getI18n(
      'giftCard.giftCardDetail.giftcardinfo_giftcardtitile',
    ),
    [EGiftCardType.StoreCreditCard]: getI18n(
      'giftCard.giftCardDetail.giftcardinfo_storetitile',
    ),
  }[type];

  return (
    <SectionWrapper
      containerClassName={css.sectionContainer}
      title={
        <Status status={status} title={title} onChangeStatus={onChangeStatus} />
      }>
      <div className={css.container}>
        {(_data || []).map((i, index) => {
          const { title, amount } = i;
          if (index === len - 1) {
            return (
              <Block
                hideBorder
                key={index}
                fixedWidth={fixedWidth}
                title={title}
                amount={fixAmountColumns({ getI18n })}
              />
            );
          } else {
            return (
              <Block
                key={index}
                fixedWidth={fixedWidth}
                title={title}
                amount={amount}
              />
            );
          }
        })}
      </div>
    </SectionWrapper>
  );
};

export default GiftCardInfo;
